import { useMemo } from 'react';
import { useMetaGetPostCreationEntitiesQuery } from '@/lib/api/requests/integrations.requests';
import type { MetaTokenStatus } from '@/lib/api/interfaces/integrations.interface';

export function useIntegration() {
  const { data: entitiesData, isLoading: isLoadingEntities, error } = useMetaGetPostCreationEntitiesQuery();
  
  const accounts = useMemo(() => entitiesData?.accounts || [], [entitiesData?.accounts]);
  const tokenStatus: MetaTokenStatus = entitiesData?.tokenStatus ?? 'not_connected';
  
  const validateAccountSelection = (accountId: string | null, postToInstagram: boolean) => {
    if (!accountId) return null;
    const account = accounts.find((acc: { id: string; instagramAllowed: boolean }) => acc.id === accountId);
    if (!account) return null;
    if (postToInstagram && !account.instagramAllowed) return null;
    return accountId;
  };

  return {
    accounts,
    isLoadingEntities,
    hasConnectedAccounts: accounts.length > 0,
    tokenStatus,
    isTokenExpired: tokenStatus === 'expired',
    isTokenExpiringSoon: tokenStatus === 'expiring_soon',
    error,
    validateAccountSelection
  };
}
